import { KeyLabel } from '../domain/key-label.model';

export enum EpgService {
  PLUTO = 'pluto',
  XUMO = 'xumo',
  PLEX = 'plex',
  SAMSUNG = 'samsung',
  LG = 'lg',
  VIZIO = 'vizio',
  TCL = 'tcl',
  ROKU = 'roku'
}

export const EpgServiceLabels = {
  [EpgService.PLUTO]: 'Pluto',
  [EpgService.XUMO]: 'Xumo',
  [EpgService.PLEX]: 'Plex',
  [EpgService.SAMSUNG]: 'Samsung',
  [EpgService.LG]: 'LG',
  [EpgService.VIZIO]: 'Vizio',
  [EpgService.TCL]: 'TCL',
  [EpgService.ROKU]: 'Roku'
};

export const EpgServiceKL = () =>
  Object.keys(EpgService).map(key =>
    new KeyLabel<EpgService>(
      EpgService[key],
      EpgServiceLabels[EpgService[key]]
    )
  )
  .sort((a, b) => a.label.localeCompare(b.label)) as KeyLabel<EpgService>[];

export const EpgServiceList = Object.values(EpgService);
